<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список гражданств</h3>
    </div>
    <div class="filters">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label for="search" class="form-label col-md-2"></label>
          <div class="col-md-9">
            <div class="input-group">
              <input class="form-control" type="text" placeholder="Поиск по наименованию"
                     id="search"
                     v-model="page.filter.search"
                     style="font-style: italic;">
              <button class="btn btn-primary" type="button" @click="reloadList()">
                Найти
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(id)="data">
        <div class="sortable-container none"
             @click="onSortChanged('id')"
             :class="{'ascending': page.sort.id === 'ASC', 'descending': page.sort.id === 'DESC'}">
          ID
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование
        </div>
      </template>

      <template #cell(id)="data">
        {{ data.item.id }}
      </template>
      <template #cell(nameRu)="data">
        {{ data.item.nameRu }}
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import citizenshipService from "@/services/citizenshipService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      page: {
        filter: {
          search: null
        },
        sort: {
          id: null,
          nameRu: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'nameRu', label: 'Наименование', sortable: true}
      ],
      items: []
    };
  },
  methods: {
    async reloadList() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await citizenshipService.getAll(token, this.page);
        this.items = response.list;
        this.totalCount = response.count;
        this.isLoading = false;
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    }
  },
  mounted() {
    this.reloadList();
  }
};
</script>

<style scoped>

.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

</style>
